module.exports = new __parcel__URL__("hatchtile.c497156f.png").toString();